import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import zh_twLocale from './zh-tw'

Vue.use(VueI18n)

export function getLanguage() {
  if (localStorage.getItem('lang')) {
    return localStorage.getItem('lang')
  }
  return 'zh'
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages: {
    en: enLocale, //英文语言包
    zh: zhLocale, //中文简体包
    zh_tw: zh_twLocale, //中文繁体包
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js